import { SET_USER_AUTH_TOKEN, SET_USER_LOGGED_IN, SET_USER_LOGGED_OUT, SET_LOGGED_IN_DEPRECATED, SET_USER_NAME, } from '../constants/actions';
const initialState = {
    loggedIn: false,
    name: '',
};
/**
 * Reduces register state.
 */
export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_AUTH_TOKEN:
            return {
                ...state,
                authToken: action.authToken,
            };
        case SET_LOGGED_IN_DEPRECATED:
        case SET_USER_LOGGED_IN:
            return {
                ...state,
                loggedIn: true,
            };
        case SET_USER_LOGGED_OUT:
            return {
                ...state,
                loggedIn: false,
            };
        case SET_USER_NAME:
            return {
                ...state,
                name: action.name,
            };
        default:
            return state;
    }
};
